
/**
 * 键盘切换表单输入选项
 * @param {*} el 
 * @param {*} binding 
 * @param {*} vnode 
 * @param {*} oldVnode 
 */
const keyupFocus = function(el, binding, vnode, oldVnode){
    const _ele_box=el||document.body;
    const _inputs=_ele_box.querySelectorAll('input');
    _ele_box.addEventListener('keyup', (ev) => {               
        if (ev.keyCode === 13) {
            let activeEl = document.activeElement;
            let nextEl = activeEl.nextElementSibling;
            nextEl && nextEl.focus();
            //const _activeElement=document.activeElement;
        }
    })
    
}
export default keyupFocus;


// WEBPACK FOOTER //
// ./src/directives/src/keyupFocus.js